import useTranslate from '../../../Hooks/useTranslate';
import Input from '../../../Style-guide/Input';
import Text from '../../../Style-guide/Text';
import ScheduleWrapper from './styles/scheduleWrapper';

const Schedule = ({ schedule, className, setSchedule }) => {
  const tr = useTranslate();
  const raw = Object.values(schedule);
  const scheduleArray = raw[0]?.dayOfWeek === 0 ? [...raw.slice(1), raw[0]] : raw;

  const handleTimeChange = (e, field) => {
    const { name, value } = e.target;

    setSchedule((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        [field]: value,
      },
    }));
  };

  const handleSwitchChange = (e) => {
    const { name, checked } = e.target;

    setSchedule((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        isWorkingDay: checked,
      },
    }));
  };

  return (
    <ScheduleWrapper className={className}>
      <Text size='SM' className='schedule-title'>
        {tr('working_schedule')}
      </Text>
      {scheduleArray?.map((day, index) => {
        const { dayName, dayOfWeek, openTime, closeTime, isWorkingDay } = day;

        return (
          <div
            className={`day-row${!isWorkingDay ? ' non-working' : ''}`}
            key={`${dayOfWeek}-${index}`}
          >
            <span className='time-input-wrapper'>
              <Input
                type='time'
                step={600}
                name={dayOfWeek}
                disabled={!isWorkingDay}
                className='time-input'
                value={openTime}
                onChange={(e) => handleTimeChange(e, 'openTime')}
              />
            </span>
            <span className='time-input-wrapper'>
              <Text size='sm'>-</Text>
              <Input
                type='time'
                step={600}
                name={dayOfWeek}
                disabled={!isWorkingDay}
                className='time-input'
                value={closeTime}
                onChange={(e) => handleTimeChange(e, 'closeTime')}
              />
            </span>
            <Input
              type='checkbox'
              name={dayOfWeek}
              className='day-switcher'
              onChange={handleSwitchChange}
              checked={isWorkingDay}
            />

            <Text size='sm' className='day-title'>
              {tr(dayName.toLowerCase()) || dayName}
            </Text>
          </div>
        );
      })}
    </ScheduleWrapper>
  );
};

export default Schedule;
